// eslint-disable-next-line no-restricted-imports
import { fromJS, Map } from '@gonfalon/immutable-shim/immutableShim';
import type { ImmutableMap } from '@gonfalon/legacy-immutable/immutableUtils';
import qs from 'qs';
import type { AnyAction } from 'redux';
import { createSelector } from 'reselect';

// eslint-disable-next-line import/no-namespace
import type * as actions from '#actions/router';
import registry from '#reducers/registry';
import type { GlobalState } from '#reducers/state';

type RouterActions = ReturnType<typeof actions.updateLocation>;

export type SearchParams<Params = {}> = { [K in keyof Params]?: string };
export type UrlQuery = { [key: string]: string | string[] | undefined };
export type QueryParams<Params extends string = string> = ImmutableMap<{ [K in Params]?: string | string[] }>;

type RouterState = ImmutableMap<
  Location & {
    query: QueryParams;
  }
>;

export function router(state: RouterState = Map(), action: AnyAction) {
  const routerAction = action as RouterActions;
  switch (routerAction.type) {
    case 'router/UPDATE_LOCATION':
      const { location } = routerAction;
      const query = qs.parse(location.search, { ignoreQueryPrefix: true });
      return fromJS({ ...location, query });
    default:
      return state;
  }
}

export function querySelector(state: GlobalState): QueryParams {
  return state.router.get('query', Map() as QueryParams);
}

const queryStringSelector = (state: GlobalState) => state.router.get('search', '');

export const searchSelector: (state: GlobalState) => UrlQuery = createSelector(
  queryStringSelector,
  (queryString) => qs.parse(queryString, { ignoreQueryPrefix: true }) as UrlQuery,
);

export const pathnameSelector = (state: GlobalState) => state.router.get('pathname', '');

registry.addReducers({ router });

declare module '#reducers/state' {
  interface GlobalState {
    router: ReturnType<typeof router>;
  }
}
